import useCartActions from "@/utils/addTocartAction";
import { message, Image, Button } from "antd";
import Link from "next/link";
import { formatCurrency } from "@/utils/utils";
import { useState } from "react";
import styles from '@/styles/addToCartSuccessModal.module.scss'


const ViewcarGoodsComponent = ({ filename, url, name, price, normalPrice, productID, successAddCart }: any) => {
  const { addToCart } = useCartActions();
  const addToCartCallBack = (response: any) => {
    if (response != "error") {
      successAddCart(response)
      message.success("Add to cart successfully!")
    }
    setLoadingBtn(false);
  }

  const [loadingBtn, setLoadingBtn] = useState(false);

  const addCart = (event: any) => {
    setLoadingBtn(true);
    addToCart(event, { productID, qty: 1 }, addToCartCallBack)
  }

  const priceArr = `${price}`.split('.');
  return (
    <div className={styles['viewcar-component']}>
      <Link href={url} legacyBehavior>
        <a rel="noopener noreferrer" target={"_blank"}>
          <Image
            src={filename}
            preview={false}
            width="100%"
            style={{ minHeight: "120px" }}
          />
        </a>
      </Link>
      <Link href={url} legacyBehavior>
        <a rel="noopener noreferrer" className={styles['goods-name']} target={"_blank"}>
          {name}
        </a>
      </Link>
      <div className={styles['price-line']}>
        <div className={styles['price']}>${priceArr[0]}.<span>{priceArr[1]}</span></div>
        {
          normalPrice
          &&
          <div className={styles['cross-price']}>{formatCurrency(normalPrice)}</div>
        }
      </div>
      <Button loading={loadingBtn} type="primary" className={styles['addcart-btn']} onClick={addCart} >Add to Cart</Button>
    </div>
  )
}

export default ViewcarGoodsComponent;